/**
 * Hausrat Endkundenrechner-API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { HausratBerechnungvorgaben } from '../model/hausrat-berechnungvorgaben.model';
// @ts-ignore
import { SchutzOptimierenKatalog } from '@comparit/common-api';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    HausratVorgabenServiceInterface,
    GetHausratSchutzOptimierenAttributeRequestParams
} from './hausrat-vorgaben.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class HausratVorgabenService extends BaseService implements HausratVorgabenServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Leistungsattribute für \&quot;Schutz optimieren\&quot;
     * Liefert die Leistungsattribute und Kacheln, die der Kunde für die angegebenen Vorgaben wählen kann. Die Vorgaben müssen vollständig sein wie für die Berechnung, sonst kommt 400. Nur Attribute mit dem dataType Boolean werden geliefert, denn der Funnel bietet nur An/Aus-Kacheln.
     * @endpoint post /api/sparte-hr/schutz-optimieren/attribute
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getHausratSchutzOptimierenAttribute(requestParameters: GetHausratSchutzOptimierenAttributeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SchutzOptimierenKatalog>;
    public getHausratSchutzOptimierenAttribute(requestParameters: GetHausratSchutzOptimierenAttributeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SchutzOptimierenKatalog>>;
    public getHausratSchutzOptimierenAttribute(requestParameters: GetHausratSchutzOptimierenAttributeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SchutzOptimierenKatalog>>;
    public getHausratSchutzOptimierenAttribute(requestParameters: GetHausratSchutzOptimierenAttributeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const hausratBerechnungvorgaben = requestParameters?.hausratBerechnungvorgaben;
        if (hausratBerechnungvorgaben === null || hausratBerechnungvorgaben === undefined) {
            throw new Error('Required parameter hausratBerechnungvorgaben was null or undefined when calling getHausratSchutzOptimierenAttribute.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/sparte-hr/schutz-optimieren/attribute`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SchutzOptimierenKatalog>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: hausratBerechnungvorgaben,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
